<template>
    <div v-if="product[0]">
        <section class="section p-0 bg d-flex align-items-center justify-content-center">
            <div class="container text-center"><h1 class="text-white">{{product[0].NAME}}</h1><Breadcrumbs :title="product[0].NAME"/></div>
        </section>
        <section class="section">
            <div class="container">
                <div class="row justify-content-md-end justify-content-center mb-4">
                    <base-button type="outline-default" 
                                 class="btn-lg"
                                 @click="showModal('Заявка на демо-версию', product[0].NAME)">
                        ЗАКАЗАТЬ ДЕМО
                    </base-button>
                    <base-button type="default" 
                                 class="btn-lg"
                                 @click="showModal('Стоимость ' + product[0].NAME, product[0].NAME)">
                        УЗНАТЬ СТОИМОСТЬ
                    </base-button>
                </div>
                <card class="row px-5 py-3" v-html="product[0].DETAIL_TEXT" shadow></card>
            </div>
        </section>
        <ContactForm></ContactForm>
        <CallModal ref="callModal"></CallModal>
    </div>
</template>
<script>
    import CallModal from "@/components/CallModal.vue";
    import ContactForm from "@/components/ContactForm.vue";
    export default {
        components: {
            ContactForm,
            CallModal
        },
        data() {
            return {
                product: [],
            };
        },
        watch: {
            '$route.params.id': function () {
                this.loadInfo()
            }
        },
        created: function () {
            this.loadInfo()
        },
        methods: {
            async loadInfo() {
                let params = new Map();
                params.set('id', this.$route.params.id);
                params.set('entity', 'products');

                this.product = await this.$root.loadContent(params);
                this.$root.title = this.product[0]['SEO']['ELEMENT_META_TITLE'];
                this.$root.description = this.product[0]['SEO']['ELEMENT_META_DESCRIPTION'];
            },
            showModal(title, name) {
                this.$refs.callModal.modals.sendApply = true;
                this.$refs.callModal.modals.title = title
                this.$refs.callModal.modals.info = name
            }
        }
    };
</script>
<style>
</style>